export const BUILD_TIME_FPS_ENABLED = false;

export const isFpsEnabledSeller = (debugPanelFpsEnabledSeller: boolean): boolean => BUILD_TIME_FPS_ENABLED || debugPanelFpsEnabledSeller;

export const isFpsEnabledBuyer = (debugPanelFpsEnabledBuyer: boolean): boolean => BUILD_TIME_FPS_ENABLED || debugPanelFpsEnabledBuyer;
